module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("Overview\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28d76211"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/warehouseAdmin/overview.vue
// module id = 817
// module chunks = 1